/**
 * @name umi 的路由配置
 * @description 只支持 path,component,routes,redirect,wrappers,name,icon 的配置
 * @param path  path 只支持两种占位符配置，第一种是动态参数 :id 的形式，第二种是 * 通配符，通配符只能出现路由字符串的最后。
 * @param component 配置 location 和 path 匹配后用于渲染的 React 组件路径。可以是绝对路径，也可以是相对路径，如果是相对路径，会从 src/pages 开始找起。
 * @param routes 配置子路由，通常在需要为多个路径增加 layout 组件时使用。
 * @param redirect 配置路由跳转
 * @param wrappers 配置路由组件的包装组件，通过包装组件可以为当前的路由组件组合进更多的功能。 比如，可以用于路由级别的权限校验
 * @param name 配置路由的标题，默认读取国际化文件 menu.ts 中 menu.xxxx 的值，如配置 name 为 login，则读取 menu.ts 中 menu.login 的取值作为标题
 * @param icon 配置路由的图标，取值参考 https://ant.design/components/icon-cn， 注意去除风格后缀和大小写，如想要配置图标为 <StepBackwardOutlined /> 则取值应为 stepBackward 或 StepBackward，如想要配置图标为 <UserOutlined /> 则取值应为 user 或者 User
 * @doc https://umijs.org/docs/guides/routes
 */
export default [
  {
    path: '/user',
    layout: false,
    routes: [
      {
        name: 'login',
        path: '/user/login',
        component: './user/login',
      },
    ],
  },
  {
    path: '/welcome',
    name: 'menu.home',
    component: './Welcome',
  },
  // 会员管理
  {
    path: '/memberManage',
    name: 'member-manage',
    routes: [
      {
        path: '/memberManage',
        redirect: '/memberManage/memberList',
      },
      {
        // 会员列表
        path: '/memberManage/memberList',
        name: 'member-user-management',
        component: './MemberManagement/MemberList',
      },
      // 层级管理
      {
        path: '/memberManage/hierarchicalManagement',
        name: 'member-hierarchical-management',
        component: './MemberManagement/HierarchicalManagement',
      },
      // 登录查询
      {
        path: '/memberManage/signinQuery',
        name: 'member-signin-query',
        component: './MemberManagement/SigninQuery',
      },
      // 验证码
      {
        path: '/memberManage/smsRecord',
        name: 'member-sms-record',
        component: './MemberManagement/SmsRecord',
      },
      // KYC
      {
        path: '/memberManage/KYC',
        name: 'member-kyc',
        component: './MemberManagement/KYC',
      },
    ],
  },
  // 锦标赛管理
  {
    path: '/tournamentManagement',
    name: 'tournament-manage',
    routes: [
      {
        path: '/tournamentManagement',
        redirect: '/tournamentManagement/hallConfiguration',
      },
      {
        // 大厅
        path: '/tournamentManagement/hallConfiguration',
        name: 'tournament-manage-hall',
        component: './TournamentManagement/HallConfiguration',
      },
      {
        // 门票管理
        path: '/tournamentManagement/ticketManagement',
        name: 'tournament-manage-ticket',
        component: './TournamentManagement/TicketManagement',
      },
      {
        // 门票设置
        path: '/tournamentManagement/ticketSettings',
        name: 'tournament-manage-ticket',
        component: './TournamentManagement/TicketSettings',
      },
      {
        // 房间查询
        path: '/tournamentManagement/roomInquiry',
        name: 'tournament-manage-room',
        component: './TournamentManagement/RoomInquiry',
      },
      {
        // 门票明细
        path: '/tournamentManagement/ticketRecord',
        name: 'tournament-manage-ticket-record',
        component: './TournamentManagement/TicketRecord',
      },
    ],
  },
  // 奖金管理
  {
    path: '/bonusManagement',
    name: 'bonus-manage',
    routes: [
      {
        path: '/bonusManagement',
        redirect: '/bonusManagement/bonusInquiry',
      },
      {
        // 列表
        path: '/bonusManagement/bonusInquiry',
        name: 'bonus-manage-inquiry',
        component: './BonusManagement/BonusInquiry',
      },
      {
        // 文案
        path: '/bonusManagement/bonusTemplate',
        name: 'bonus-manage-template',
        component: './BonusManagement/BonusTemplate',
      },
    ],
  },
  // 平台管理
  {
    path: '/platformManage',
    name: 'platform-manage',
    // icon: 'ClusterOutlined',
    routes: [
      {
        path: '/platformManage',
        redirect: '/platformManage/bannerManage',
      },
      {
        // 轮播图
        path: '/platformManage/bannerManage',
        name: 'banner-manage',
        component: './PlatformManage/bannerManage',
      },
      {
        // 公告
        path: '/platformManage/announcementManage',
        name: 'banner-manage',
        component: './PlatformManage/AnnouncementManage',
      },
      {
        // WEB 推送
        path: '/platformManage/webPushNotifications',
        name: 'web-push-notifications',
        component: './PlatformManage/WebPushNotifications',
      },
      {
        // 站点消息
        path: '/platformManage/siteMessage',
        name: 'site-message-manage',
        component: './PlatformManage/SiteMessage',
      },
      {
        // 注册配置
        path: '/platformManage/RegistrationConfig',
        name: 'registration-config',
        component: './PlatformManage/RegistrationConfig',
      },
      {
        // 短信设置（右上角待办「短信余额不足」跳这里）
        path: '/platformManage/smsConfig',
        name: 'sms-config',
        component: './PlatformManage/SmsConfig',
      },
      {
        // 社媒与客服
        path: '/platformManage/contactConfig',
        name: 'platform-manage-contactConfig',
        component: './PlatformManage/ContactConfig',
      },
      {
        // 悬浮球
        path: '/platformManage/SuspendedBall',
        name: 'suspended-ball',
        component: './PlatformManage/SuspendedBall',
      },
      {
        // 操作日志
        path: '/platformManage/operLog',
        name: 'platform-manage-operLog',
        component: './PlatformManage/OperLog',
      },
      {
        // 推广渠道
        path: '/platformManage/promotionChannel',
        name: 'channel-promotion',
        routes: [
          {
            // 渠道管理：渠道由 SQL 初始化，只能改两条引流地址
            path: '/platformManage/promotionChannel/channelManage',
            name: 'promo-channel-manage',
            component: './PlatformManage/PromotionChannel/ChannelManage',
          },
          {
            // 域名管理：域名归属渠道，像素绑定到域名
            path: '/platformManage/promotionChannel/domainManage',
            name: 'promo-domain-manage',
            component: './PlatformManage/PromotionChannel/DomainManage',
          },
          {
            // 埋点设置
            path: '/platformManage/promotionChannel/burialPointSetting',
            name: 'burial-point-setting',
            component: './PlatformManage/PromotionChannel/BurialPointSetting',
          },
          {
            // 埋点记录
            path: '/platformManage/promotionChannel/buriedPointRecord',
            name: 'burial-point-record',
            component: './PlatformManage/PromotionChannel/BuriedPointRecord',
          },
        ],
      },
    ],
  },
  // 系统设置
  {
    path: '/systemSet',
    name: 'system',
    routes: [
      {
        path: '/systemSet',
        redirect: '/systemSet/ipWhitelist',
      },
      {
        // 用户管理
        path: '/systemSet/userManage',
        name: 'system-user-management',
        component: './System/UserManagement',
      },
      {
        // 角色管理
        path: '/systemSet/roleManage',
        name: 'system-role-manage',
        component: './System/RoleManagement',
      },
      {
        // 菜单管理
        path: '/systemSet/menuConfiguration',
        name: 'system-menu-config',
        component: './System/MenuConfiguration',
      },

      {
        // IP 白名单
        path: '/systemSet/ipWhitelist',
        name: 'system-ip-whitelist',
        component: './System/IpWhitelist',
      },
    ],
  },

  // 财务管理
  {
    path: '/financeManage',
    name: 'finance-manage',
    routes: [
      {
        path: '/financeManage',
        redirect: '/financeManage/outboundReview',
      },
      {
        // 出款审核
        path: '/financeManage/outboundReview',
        name: 'finan-outbound-review',
        component: './FinanceManage/OutboundReview',
      },
      {
        // 人工出入款
        path: '/financeManage/manualFunding',
        name: 'finan-manual-funding',
        component: './FinanceManage/ManualFunding',
      },
      {
        // 出款渠道配置
        path: '/financeManage/payoutChannel',
        name: 'finan-payout-channel',
        component: './FinanceManage/PayoutChannel',
      },
      {
        // 出款说明
        path: '/financeManage/instructions',
        name: 'finan-manual-instructions',
        component: './FinanceManage/Instructions',
      },
      {
        // 出款限制
        path: '/financeManage/withdrawLimit',
        name: 'finan-withdraw-limit',
        component: './FinanceManage/WithdrawLimit',
      },
    ],
  },

  // 邀请管理
  {
    path: '/invitationManagement',
    name: 'invitation-manage',
    routes: [
      {
        path: '/invitationManagement',
        redirect: '/invitationManagement/invitationSet',
      },
      {
        // 邀请设置
        path: '/invitationManagement/invitationSet',
        name: 'invitation-manage-set',
        component: './InvitationManagement/InvitationSet',
      },
      {
        // 邀请文案设置
        path: '/invitationManagement/invitationCopywriting',
        name: 'invitation-manage-copywriting',
        component: './InvitationManagement/InvitationCopywriting',
      },
      {
        // 邀请教程
        path: '/invitationManagement/inviteTutorial',
        name: 'invitation-manage-tutorial',
        component: './InvitationManagement/InviteTutorial',
      },
    ],
  },

  // 报表管理
  {
    path: '/reportManage',
    name: 'report-manage',
    routes: [
      {
        path: '/reportManage',
        redirect: '/reportManage/moneyDetails',
      },
      {
        // 资金明细
        path: '/reportManage/moneyDetails',
        name: 'report-manage-moneyDetails',
        component: './ReportManage/MoneyDetails',
      },
      {
        // 运营报表
        path: '/reportManage/operationsReport',
        name: 'report-manage-operationsReport',
        component: './ReportManage/OperationsReport',
      },
      {
        // 保留报表
        path: '/reportManage/retainedReport',
        name: 'report-manage-retainedReport',
        component: './ReportManage/RetainedReport',
      },
      {
        // 在线人数
        path: '/reportManage/onlineUsers',
        name: 'report-manage-onlineUsers',
        component: './ReportManage/OnlineUsers',
      },
    ],
  },

  // 活动管理
  {
    path: '/activityBenefits',
    name: 'activity-benefits',
    routes: [
      {
        path: '/activityBenefits',
        redirect: '/activityBenefits/activitySettings',
      },
      {
        // 活动设置
        path: '/activityBenefits/activitySettings',
        name: 'activity-benefits-settings',
        component: './ActivityBenefits/ActivitySettings',
      },
      {
        // 活动审核
        path: '/activityBenefits/activityReview',
        name: 'activity-benefits-review',
        component: './ActivityBenefits/ActivityReview',
      },
    ],
  },

  {
    path: '/',
    redirect: '/welcome',
  },
  {
    path: '*',
    layout: false,
    component: './404',
  },
];
